import { render, staticRenderFns } from "./ProductoEmpresaAyuda.vue?vue&type=template&id=5dfffd6c&scoped=true&"
import script from "./ProductoEmpresaAyuda.vue?vue&type=script&lang=js&"
export * from "./ProductoEmpresaAyuda.vue?vue&type=script&lang=js&"
import style0 from "./ProductoEmpresaAyuda.vue?vue&type=style&index=0&id=5dfffd6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfffd6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VIcon})
